import React from 'react';
import styled from 'styled-components/macro';
import scaleSize from 'utils/scale-size';
import { LoaderComponent } from 'components/Loader';

export const LoaderWrapper = styled.div`
  width: ${scaleSize(384)}px;
  height: ${scaleSize(1080)}px;
  position: absolute;
  top: -${scaleSize(70)}px;
  right: -${scaleSize(530)}px;
`;

export default () => (
  <LoaderWrapper>
    <LoaderComponent />
  </LoaderWrapper>
);
